<template>
  <div class="tw-flex tw-items-center">
    <div class="tw-mr-1 tw-flex tw-flex-wrap tw-gap-1">
      <Badge variant="outline" v-for="payment in sepaPayment.payment_numbers" :key="payment.id">
        <router-link
          :to="{ name: 'payment', params: { id: payment.id } }"
          class="tw-text-blue-600 hover:tw-text-blue-800 hover:tw-underline"
        >
          {{ payment.payment_number }}
        </router-link>
      </Badge>
    </div>
  </div>
</template>

<script setup lang="ts">
import Badge from '@/components/ui/badge/Badge.vue';
import type { CellContext } from '@tanstack/vue-table';
import { computed } from 'vue';

const props = defineProps<{
  info: CellContext<any, any>;
}>();

const sepaPayment = computed(() => props.info.row.original);
</script>
